import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AgencyMetricsQueryVariables = Types.Exact<{
  agencyId: Types.Scalars['ID'];
  date: Types.Scalars['Date'];
  where?: Types.InputMaybe<Types.CourierFilterInput>;
}>;


export type AgencyMetricsQuery = { __typename?: 'Query', CouriersByAgency: Array<{ __typename?: 'Courier', courierId: number, indicative?: string | null, SystemGeneratedItineraryMetrics?: { __typename?: 'CourierMetrics', distanceInMeters?: any | null, durationInSeconds?: any | null } | null, CourierGeneratedItineraryMetrics?: { __typename?: 'CourierMetrics', distanceInMeters?: any | null, durationInSeconds?: any | null } | null, TrafficDataItineraryMetrics?: { __typename?: 'TrafficDataCourierMetrics', distanceInMeters?: any | null, durationInSeconds?: any | null } | null, LateRefillMetrics?: { __typename?: 'CourierLateRefillMetrics', courierDesignedDistanceInMeters?: any | null, courierDesignedDurationInSeconds?: any | null, defaultItineraryDistanceInMeters?: any | null, defaultItineraryDurationInSeconds?: any | null, combinedStatisticsDurationInSeconds?: any | null, combinedStatisticsDistanceInMeters?: any | null } | null }> };


export const AgencyMetricsDocument = gql`
    query AgencyMetrics($agencyId: ID!, $date: Date!, $where: CourierFilterInput) {
  CouriersByAgency(agencyId: $agencyId, date: $date, where: $where) {
    courierId
    indicative
    SystemGeneratedItineraryMetrics(date: $date) {
      distanceInMeters
      durationInSeconds
    }
    CourierGeneratedItineraryMetrics(date: $date) {
      distanceInMeters
      durationInSeconds
    }
    TrafficDataItineraryMetrics(date: $date) {
      distanceInMeters
      durationInSeconds
    }
    LateRefillMetrics(date: $date) {
      courierDesignedDistanceInMeters
      courierDesignedDurationInSeconds
      defaultItineraryDistanceInMeters
      defaultItineraryDurationInSeconds
      combinedStatisticsDurationInSeconds
      combinedStatisticsDistanceInMeters
    }
  }
}
    `;

/**
 * __useAgencyMetricsQuery__
 *
 * To run a query within a React component, call `useAgencyMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencyMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyMetricsQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      date: // value for 'date'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAgencyMetricsQuery(baseOptions: Apollo.QueryHookOptions<AgencyMetricsQuery, AgencyMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgencyMetricsQuery, AgencyMetricsQueryVariables>(AgencyMetricsDocument, options);
      }
export function useAgencyMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgencyMetricsQuery, AgencyMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgencyMetricsQuery, AgencyMetricsQueryVariables>(AgencyMetricsDocument, options);
        }
export type AgencyMetricsQueryHookResult = ReturnType<typeof useAgencyMetricsQuery>;
export type AgencyMetricsLazyQueryHookResult = ReturnType<typeof useAgencyMetricsLazyQuery>;
export type AgencyMetricsQueryResult = Apollo.QueryResult<AgencyMetricsQuery, AgencyMetricsQueryVariables>;